import { render, staticRenderFns } from "./CreateTemplateModal.vue?vue&type=template&id=b12e45de&scoped=true"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateModal.vue?vue&type=style&index=0&id=b12e45de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12e45de",
  null
  
)

export default component.exports